import { render } from "./ProjectRegionSummary.vue?vue&type=template&id=8bd9c6d6&scoped=true&ts=true"
import script from "./ProjectRegionSummary.ts?vue&type=script&lang=ts"
export * from "./ProjectRegionSummary.ts?vue&type=script&lang=ts"

import "./ProjectRegionSummary.scss?vue&type=style&index=0&id=8bd9c6d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd9c6d6"]])

export default __exports__